import {FlowSchedule} from "../../../../lib/src/api/repositories/flows-repository";
import {FC, useMemo} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faCircleExclamation,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import {JaneEmployee} from "../../resources/EmployeeContext";
import {SearchPaginateReload} from "../../../../lib/src/components/data/SearchAndPaginate";
import DataTable from "../../../../lib/src/components/data-table/DataTable";


interface EnhancedFlowSchedule extends FlowSchedule {
  employeeOnsId: number|null
  employeeNumber: string|null
  employeeName: string|null
  status: 'gepland'|'afgerond'|'fout'
  scheduledAt: Date
  afgerondAt: Date|null
  failedAt: Date|null
}

export const FlowScheduleIndexTable: FC<{isLoading: boolean, schedules: FlowSchedule[], employees: JaneEmployee[]}> = props => {
  // const sortedSchedules = props.files.sort((a,b) => a.name.localeCompare(b.name))
  const enhancedSchedules: EnhancedFlowSchedule[] = useMemo(() => {
    const employeeTableBySub = props.employees.reduce((acc, employee) => {
      acc[employee.sub] = employee
      return acc
    }, {} as {[sub:string]: JaneEmployee})
    return props.schedules.map((schedule) => {
      let status: 'gepland'|'afgerond'|'fout'
      if (schedule.finished_at) {
        status = 'afgerond'
      } else if (schedule.executed_at) {
        status = 'fout'
      } else {
        status = 'gepland'
      }
      return {
        ...schedule,
        employeeOnsId: employeeTableBySub[schedule.keycloak_sub]?.id ?? null,
        employeeNumber: employeeTableBySub[schedule.keycloak_sub]?.employee_number ?? null,
        employeeName: employeeTableBySub[schedule.keycloak_sub]?.name ?? null,
        status,
        scheduledAt: new Date(schedule.scheduled_at),
        afgerondAt: schedule.finished_at ? new Date(schedule.finished_at) : null,
        failedAt: schedule.executed_at ? new Date(schedule.executed_at) : null,
      }
    }).sort((a,b) => b.scheduledAt.getTime() - a.scheduledAt.getTime())
  }, [])

  return <SearchPaginateReload data={enhancedSchedules} paginationEnabled={true} filterProperties={['employeeName', 'employeeNumber', 'scheduled_at', 'status']} resultsBuilder={(results) => {
    return <DataTable keyProperty={'id'} compact={true} loading={props.isLoading} data={results} columns={[
      {property: 'id', header: 'ID', transform: (id) => <span className={'text-xs text-slate-600 font-medium font-mono'}>{id}</span>},
      {property: 'scheduledAt', header: 'Gepland', transform: (scheduledAt) => scheduledAt.toLocaleDateString('nl-NL', {year: 'numeric', month: '2-digit', day: '2-digit'})},
      {property: 'employeeNumber', header: 'Mw. Nummer'},
      {property: 'employeeName', header: 'Medewerker'},
      {property: 'status', header: 'Status', transform: (status) => <FlowScheduleIndexTableStatusBadge status={status} />},
      {property: 'updated_at', header: 'Laatste update', transform: (v) => new Date(v).toLocaleDateString('nl-NL', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', 'minute': '2-digit'})},
    ]} placeholder={'Nog geen geplande runs'}/>
  }} />
}

const FlowScheduleIndexTableStatusBadge: FC<{status: EnhancedFlowSchedule['status']}> = props => {
  if (props.status === 'gepland') {
    return <span className={'inline-flex items-center bg-blue-600 pl-1 pr-3 py-1 rounded-full'}>
      <FontAwesomeIcon icon={faClock} className={'text-white mr-2'} />
      <span className={'fond-bold text-white text-xs'}>Gepland</span>
    </span>
  }
  if (props.status === 'fout') {
    return <span className={'inline-flex items-center bg-red-600 pl-1 pr-3 py-1 rounded-full'}>
      <FontAwesomeIcon icon={faCircleExclamation} className={'text-white mr-2'} />
      <span className={'fond-bold text-white text-xs'}>Fout</span>
    </span>
  }
  return <span className={'inline-flex items-center bg-green-600 pl-1 pr-3 py-1 rounded-full'}>
    <FontAwesomeIcon icon={faCircleCheck} className={'text-white mr-2'} />
    <span className={'fond-bold text-white text-xs'}>Afgerond</span>
  </span>
}